export const invertMap = (
  initial: Record<string, string>
): Record<string, string> => {
  return Object.fromEntries(Object.entries(initial).map(([k, v]) => [v, k]));
};
